<template>
  <v-card class="edit-class" flat>
    <div class="band">
      <v-btn
        fab
        small
        color="white"
        outlined
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon dark>close</v-icon>
      </v-btn>
    </div>
    <v-row class="ma-3">
      <v-col cols="12">
        <h2 class="headline">Class Details</h2>
        <p>You can change details of your class in this section</p>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="className" label="Class Name" />
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          :items="yearLevels"
          item-text="value"
          item-value="id"
          v-model="yearLevel"
          label="Class Year Level"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-row justify="end">
          <v-dialog
            v-model="deleteDialogConfirmation"
            persistent
            max-width="600px"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="red darken-1" dark v-on="on">
                Delete this class
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Delete this class</span>
              </v-card-title>
              <v-card-text>
                Once you delete this class, all the data for the class will be
                lost for ever. Are you sure you want to go ahead?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="deleteDialogConfirmation = false">
                  Close
                </v-btn>
                <v-btn
                  class="ml-3"
                  color="red darken-1"
                  text
                  @click="deleteClass"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn class="ml-3" color="primary" @click="editClass">
            Update
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import YearLevel from '@/modules/lesson/models/YearLevel'
import Class from '@/modules/class/models/Class'

export default {
  name: 'EditClass',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      deleteDialogConfirmation: false,
      yearLevel: null,
      className: null,
      newClass: false,
      active: 0
    }
  },
  async mounted() {
    await YearLevel.dispatch('fetch')

    this.className = this.customClass.name
    this.yearLevel = this.customClass.year_levels[0].id
  },
  computed: {
    yearLevels() {
      return YearLevel.all()
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    async deleteClass() {
      await Class.dispatch('destroy', {
        customClassId: this.customClass.id,
        mod: 'teacher'
      })
      this.deleteDialogConfirmation = false
      let query = Object.assign({}, this.$route.query)
      const keysToRemove = [
        'currentClassId',
        'currentParentTab',
        'currentChildTab'
      ]
      keysToRemove.forEach(e => delete query[e])
      this.$router.push({ query })
    },
    async editClass() {
      const payload = {
        id: this.customClass.id,
        name: this.className,
        yearLevel: this.yearLevel,
        module: 'teacher'
      }
      await Class.dispatch('updateClass', { payload })

      this.showSnackbar('Class edited successfully')

      this.$emit('closeTab')
    }
  }
}
</script>

<style lang="scss">
.edit-class {
}
</style>
